import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import soundManager from "slotworks/sound/sound-manager";
import HarleyComponents from "components/components";

export default class ReelAnimationsComponent {

    private layer: Layers;
    private started: boolean = false;
    private animating: boolean = false;

    constructor() {

    }

    public init() {
        this.layer = Layers.MatrixBackground;

        Components.matrix.startSignal.add(this.onStart);
        Components.matrix.landSignal.add(this.onLand);

        for (let i = 1; i <= 5; i++) {
            const anim = Layers.MatrixBackground.getAnimatedSprite("active" + i);
            anim.visible = true;
            anim.loop = true;
        }
    }

    public stop() {
        this.animating = false;
        for (let i = 1; i <= 5; i++) {
            const anim = Layers.MatrixBackground.getAnimatedSprite("active" + i);
            anim.stop();
            anim.visible = false;
        }

        for (let i = 3; i <= 5; i++) {
            const border = Layers.Custom.get("Anticipation").getAnimatedSprite("borderantic" + i);
            if (border) {
                border.stop();
                border.visible = false;
            }
        }

        HarleyComponents.background.stopAnticipation();
    }

    private onStart = () => {
        for (let i = 1; i <= 5; i++) {
            const anim = Layers.MatrixBackground.getAnimatedSprite("active" + i);
            anim.visible = true;
            anim.gotoAndPlay((i - 1) * 3);
        }
        this.started = false;
        this.animating = true;
    }

    private onLand = (index: number) => {
        const record = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;
        const anticipations = record.anticipations;
        this.stopAnticipation(index);
        if (index === 5) {
            HarleyComponents.background.stopAnticipation();
            this.animating = false;
            for (let i = 1; i <= 5; i++) {
                const anim = Layers.MatrixBackground.getAnimatedSprite("active" + i);
                anim.stop();
                anim.visible = false;
            }

            for (let i = 3; i <= 5; i++) {
                const border = Layers.Custom.get("Anticipation").getAnimatedSprite("borderantic" + i);
                if (border) {
                    border.stop();
                    border.visible = false;
                }
            }
        } else {
            if(!this.animating) return;

            const anticipate = anticipations.reelAnticipations[index];
            if(anticipate) { 
                this.startAnticipationOnIndex(index + 1);
                if(!this.started) {
                    HarleyComponents.background.startAnticipation();
                    this.started = true;
                    let harleyAnticipation = false;
                    let scatterAnticipation = false;
                    for(let lands of anticipations.landSymbols) {
                        for(let symbol of lands) {
                            if(symbol === "HARLEY") {
                                harleyAnticipation = true;
                                break;
                            } else if(symbol === "SCATTER") {
                                scatterAnticipation = true;
                                break;
                            }
                        }
                        if(harleyAnticipation || scatterAnticipation) {
                            break;
                        }
                    }
                    if(harleyAnticipation) {
                        // Harley anticipation, light all reels
                        this.startAnticipationFromIndex(index + 1);
                    }
                }
            }            
        }

        if(index > 1 && anticipations?.landSymbols[index - 1]?.includes("SCATTER")) {
            soundManager.customEvent("scatter_land_" + index);
        }
    }

    private startAnticipationFromIndex = (index: number) => {
        for(let i = index; i <= 5; i++) {
            const anim = Layers.MatrixBackground.getAnimatedSprite("antic" + i);
        
            if(anim) {
                anim.gotoAndPlay(0);
                anim.visible = true;
            }
        }
    }

    private startAnticipationOnIndex = (index: number) => {
        const anim = Layers.MatrixBackground.getAnimatedSprite("antic" + index);
        
        if(anim) {
            anim.gotoAndPlay(0);
            anim.visible = true;
        }

        const border = Layers.Custom.get("Anticipation").getAnimatedSprite("borderantic" + index);
        if(border) {
            border.gotoAndPlay(0);
            border.visible = true;
        }
    }

    private stopAnticipationOnIndex = (index: number) => {
        const anim = Layers.MatrixBackground.getAnimatedSprite("antic" + index);
        if(anim) {
            anim.stop();
            anim.visible = false;
        }

        const border = Layers.Custom.get("Anticipation").getAnimatedSprite("borderantic" + index);
        if(border) {
            border.stop();
            border.visible = false;
        }
    }

    private stopAnticipation(index: number) {
        // borderantic, antic
        for (let i = 3; i <= index && i <= 5; i++) {
            const anim = Layers.MatrixBackground.getAnimatedSprite("antic" + i);
            if (anim) {
                anim.stop();
                anim.visible = false;
            }

            const border = Layers.Custom.get("Anticipation").getAnimatedSprite("borderantic" + i);
            if (border) {
                border.stop();
                border.visible = false;
            }
        }
    }
}